export const tableHeader = [
  'Branch Name',
  'City',
  'Zip Code',
  'Mobile Number',
  'Email',
  'Main Branch',
  'Question Limit',
  'Status',
  'Action'
]
